<div class="marine-insurance-payment-button" *ngIf="isPaymentAvailable">
  <ng-container *ngIf="isHasInstantPayment">
    <payment-button [referenceNumber]="referenceNumber" [isDisabled]="isDisabled"></payment-button>
  </ng-container>
  <ng-container *ngIf="!isHasInstantPayment">
    <button type="button" class="btn btn-primary" (click)="confirmPayment()">
      {{ "CONFIRM_PAYMENT" | translate }}
    </button>
  </ng-container>
</div>
